import { styled, Typography } from "@mui/material";
import { ClipboardCopy } from "@volt_developers/components";
import { useState } from "react";

import { ShowSecretButton } from "./ShowSecretButton";

const SECRET_PLACEHOLDER = "••••••••••••";

export interface CardClipboardSecretTextProps {
  text: string;
  "data-testid"?: string;
}

export function CardClipboardSecretText({
  "data-testid": dataTestId,
  text,
}: CardClipboardSecretTextProps) {
  const [isSecretVisible, setIsSecretVisible] = useState(false);
  const toggleSecretVisibility = () => setIsSecretVisible((prev) => !prev);

  return (
    <Wrapper data-testid={dataTestId}>
      {isSecretVisible ? (
        <Typography variant="small">{text}</Typography>
      ) : (
        <Typography
          sx={{
            fontSize: 25,
            letterSpacing: 5,
            lineHeight: "20px",
          }}
        >
          {SECRET_PLACEHOLDER}
        </Typography>
      )}
      <ClipboardCopy sx={{ mt: 0.25 }} textToCopy={text}>
        {null}
      </ClipboardCopy>
      <ShowSecretButton
        data-testid={dataTestId ? `${dataTestId}-toggle-button` : undefined}
        isSecretVisible={isSecretVisible}
        onClick={toggleSecretVisibility}
      />
    </Wrapper>
  );
}

const Wrapper = styled("div")({
  display: "flex",
  alignItems: "center",
});
